/* eslint-disable @next/next/no-img-element */
import dayjs from "dayjs";
import { isArray } from "lodash";
import { numberWithCommas } from "utilities/helper";
import { getLinkArticle } from "./articleComponent";

export default function ImageComponent({ item, slug }) {
    let link = getLinkArticle(item, slug);

    if (item.storage_emagazine_url) {
        link = ((item.status_code == 0 || item.status_code == 2) ? '/preview' : '') + `/happynest-story/` + item.id + '/' + item.slug;
    }

    const luotThich = numberWithCommas(item.interaction_count.like_count_number);
    const luotXem = numberWithCommas(item.interaction_count.view_count_number);
    let time = item.created_at ? dayjs(item.created_at).format("DD/MM/YYYY") : "";
    if (isArray(item.published_at_detail_formatted.split(' '))) {
        time = item.published_at_detail_formatted.split(' ')[0];
    }
    return (
        <div className="newsPost">
            <a href={link}>
                <div className="newsPost-thumb wrap-next-image">
                    <img alt="" src={item.storage_thumbnail_url_wide || item.storage_thumbnail_url || item.storage_thumbnail_url_large} />
                </div>
            </a>
            <div className="newsPost-content">
                <h3 className="title">
                    <a href={link}>
                        {item.title}
                    </a>
                </h3>
                <div className="newsPost-wrap">
                    <div className="acc acc-small">
                        <span><img alt={item?.user?.display_name} src={item?.user?.avatar || '/images/icon-app.svg'} /></span>
                        <span className='name'>{item?.user?.display_name}</span>
                    </div>
                    <span className="date">{time}</span>
                </div>
                <p className="view">{luotThich} lượt thích | {luotXem} lượt xem</p>
            </div>
        </div>
    );
}